module.exports = __webpack_public_path__ + "img/thai.e055eee6.webp";